(function () {
  'use strict';
  var selector = '[data-m04-story]';
  function initialize(scope) {
    scope.querySelectorAll(selector).forEach(function (root) {
      if (root.m04Cleanup) return;
      var stage = root.querySelector('[data-m04-stage]') || root.querySelector('.m04-stage');
      var product = root.querySelector('.m04-product');
      var images = Array.prototype.slice.call(root.querySelectorAll('[data-m04-image]'));
      var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-m04-swatch]'));
      var counter = root.querySelector('[data-m04-current]');
      var total = images.length;
      if (!stage || !product || !total) return;
      var controller = new AbortController();
      var frame = 0;
      var step = 0;
      var travel = 0;
      var selected = -1;
      var editorIndex = null;
      var renderedProgress = null;
      var previousTime = 0;
      var mobileQuery = window.matchMedia('(max-width:900px)');
      var reducedMotion = (window.SaguaroMotion ? window.SaguaroMotion() : matchMedia('(prefers-reduced-motion: reduce)'));
      // Decode upcoming colours before their clipped layer is revealed.
      function preloadImages() {
        images.forEach(function (image) { if (image.tagName === 'IMG') { image.loading = 'eager'; if (image.decode) image.decode().catch(function () {}); } });
      }
      var preloadObserver = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) { preloadImages(); preloadObserver.disconnect(); }
      }, { rootMargin: '100% 0px' }) : null;
      if (preloadObserver) preloadObserver.observe(root); else preloadImages();
      function listen(target, type, callback, passive) {
        target.addEventListener(type, callback, { signal: controller.signal, passive: !!passive });
      }
      function clamp(value, min, max) { return Math.min(max, Math.max(min, value)); }
      function number(element, name, fallback) {
        var value = parseFloat(element.getAttribute(name));
        return isFinite(value) ? value : fallback;
      }
      function update(now) {
        frame = 0;
        var elapsed = clamp(-root.getBoundingClientRect().top, 0, travel);
        var targetProgress = editorIndex !== null ? editorIndex : elapsed / Math.max(step, 1);
        var dt = Math.min(Math.max((now - previousTime) / 1000, 0), .05);
        previousTime = now;
        if (renderedProgress === null || reducedMotion.matches || editorIndex !== null || targetProgress <= 0 || targetProgress >= total || Math.abs(targetProgress - renderedProgress) > 1) renderedProgress = targetProgress;
        else renderedProgress += (targetProgress - renderedProgress) * (1 - Math.exp(-dt / .1));
        var settling = Math.abs(targetProgress - renderedProgress) > .0001;
        if (!settling) renderedProgress = targetProgress;
        var raw = renderedProgress;
        var current = Math.min(total - 1, Math.floor(raw));
        var next = Math.min(total - 1, current + 1);
        // Each colour rests before a scrubbed bottom-to-top wipe; the last rests before unpinning.
        var wipe = current === next ? 0 : clamp((raw - current - .35) / .65, 0, 1);
        var active = wipe >= .5 ? next : current;
        if (reducedMotion.matches) { current = active; next = active; wipe = 0; }
        var cut = (1 - wipe) * 100;
        images.forEach(function (image, index) {
          var visible = index === current || (index === next && wipe > 0);
          image.style.opacity = visible ? '1' : '0';
          image.style.zIndex = index === next ? '2' : '1';
          image.style.clipPath = index === next && next !== current ? 'inset(' + cut.toFixed(3) + '% 0 0 0)' : index === current && next !== current ? 'inset(0 0 ' + (100 - cut).toFixed(3) + '% 0)' : 'inset(0)';
          image.setAttribute('aria-hidden', index === active ? 'false' : 'true');
        });
        root.style.setProperty('--m04-progress', String(clamp(elapsed / Math.max(travel, 1), 0, 1)));
        root.setAttribute('data-active-color', String(active));
        root.setAttribute('data-wipe-progress', wipe.toFixed(4));
        if (selected !== active) {
          selected = active;
          swatches.forEach(function (swatch, index) { swatch.setAttribute('aria-pressed', index === active ? 'true' : 'false'); });
          var swatch = swatches[active];
          if (swatch) {
            var rail = swatch.parentElement;
            var swatchRect = swatch.getBoundingClientRect();
            var railRect = rail.getBoundingClientRect();
            if (swatchRect.left < railRect.left || swatchRect.right > railRect.right) rail.scrollLeft += swatchRect.left - railRect.left - (railRect.width - swatchRect.width) / 2;
          }
          if (counter) counter.textContent = String(active + 1).padStart(2, '0');
        }
        if (settling) frame = requestAnimationFrame(update);
      }
      function schedule() { if (!frame) frame = requestAnimationFrame(update); }
      function resize() {
        var height = stage.getBoundingClientRect().height;
        var configuredStep = clamp(number(root, 'data-scroll-step', 85), 40, 200);
        // Keep the colour story expressive on small screens without making the
        // section several full viewports long. The editor value still controls
        // desktop; mobile uses a measured upper bound for a quicker pass.
        if (mobileQuery.matches) configuredStep = Math.min(configuredStep, 38);
        step = height * configuredStep / 100;
        travel = total > 1 ? total * step : 0;
        root.style.setProperty('--m04-scroll-height', (height + travel) + 'px');
        root.classList.add('is-ready');
        schedule();
      }
      function goTo(index) {
        editorIndex = null;
        var top = window.scrollY + root.getBoundingClientRect().top;
        window.scrollTo({ top: top + clamp(index, 0, total - 1) * step, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      }
      swatches.forEach(function (swatch, index) { listen(swatch, 'click', function () { goTo(index); }); });
      listen(window, 'scroll', schedule, true);
      listen(window, 'resize', resize, true);
      listen(mobileQuery, 'change', resize);
      listen(reducedMotion, 'change', schedule);
      listen(root, 'shopify:block:select', function (event) {
        var id = event.detail && event.detail.blockId;
        var index = swatches.findIndex(function (swatch) { return swatch.getAttribute('data-block-id') === id || swatch.contains(event.target); });
        if (index < 0) return;
        editorIndex = index;
        schedule();
      });
      listen(root, 'shopify:block:deselect', function () { editorIndex = null; schedule(); });
      var observer = window.ResizeObserver ? new ResizeObserver(resize) : null;
      if (observer) observer.observe(stage);
      resize();
      root.m04Cleanup = function () {
        controller.abort();
        if (observer) observer.disconnect();
        if (preloadObserver) preloadObserver.disconnect();
        if (frame) cancelAnimationFrame(frame);
        root.classList.remove('is-ready');
        root.style.removeProperty('--m04-scroll-height');
        delete root.m04Cleanup;
      };
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  else initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll(selector).forEach(function (root) { if (root.m04Cleanup) root.m04Cleanup(); });
  });
}());
